import { Component, OnInit, Input } from '@angular/core';
import { Grade } from 'app/models/grade';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from 'app/utils/notifications.service';
import { GradeService } from 'app/core/grade.service';

@Component({
  selector: 'app-ajout-grade',
  templateUrl: './ajout-grade.component.html',
  styleUrls: ['./ajout-grade.component.css']
})
export class AjoutGradeComponent implements OnInit {


  @Input()
  grade:Grade;
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
    private notification: NotificationsService,
    private gradeService:GradeService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  submitForm() {
    const valeur: any = this.form.value;

    console.log(valeur);
    this.gradeService.create(valeur).subscribe(
      catheter => {
        if (this.grade) {
          this.notification.addToast(
            " Modification Réussi",
            "infos",
            "success"
          );
        } else {
          this.notification.addToast(
            " Crétion Réussi",
            "infos",
            "success"
          );
        }
      },
      error => {
        if (this.grade) {
          this.notification.addToast(
            "Erreur sur Modification",
            'Attention', 'error'
          );
        } else {
          this.notification.addToast(
            "Erreur sur Création",
            'Attention', 'error'
          );
        }
      }
    );

    this.activeModal.dismiss("cancelled by user");
    this.ngOnInit();
  }


  public initForm() {
    if (this.grade) {
      this.form = this.formBuilder.group({
        libelle: [this.grade.libelle, Validators.required],
        etat: [this.grade.etat, Validators.required],
        id: [this.grade.id]
      });
    } else {
      this.form = this.formBuilder.group({
        libelle: [null, Validators.required],
        etat: [true],
        id: [null]
      });
    }
  }
  dismiss() {
    this.activeModal.dismiss("cancelled by user");
  }


}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/parametrage/grade/ajout-grade/ajout-grade.component.ts